import { DataType, IValidationError } from 'flux-definition';
import { AbstractDataItem } from './data-item-abstract';

/**
 * Data item class for the BINARY data type. Data items in shape models with the BINARY
 * data type will be deserialized into instances of this class by the `DataItemFactory`.
 */
export class BinaryDataItem extends AbstractDataItem<DataType.BINARY> {
    /**
     * Checks whether the given value is valid (returns the error if any)
     */
    public validate( value: typeof BinaryDataItem.prototype.value ): IValidationError {
        if ( value === undefined ) {
            return null;
        }
        if ( value === true || value === false ) {
            return null;
        }
        return { message: `"${value}" is not a valid boolean value` };
    }
}
